export const root = state => state.get('events');
export const events = state => root(state).get('entities');
export const eventById = (state, id) => events(state).get(String(id));
export const eventsByIds = (state, ids) => ids.map(id => eventById(state, id));
